'use client';

/**
 * @file Permission-wrapper.tsx
 * @description Wrapper to render children if user has required permission(s)
 * @version 0.0.2
 */
import { createContext } from 'react';

export const PermissionContext = createContext([]);

export const PermissionProvider = ({ children, permissions }) => {
  return <PermissionContext.Provider value={permissions}>{children}</PermissionContext.Provider>;
};
